"use strict";

var HTTP_METHODS = {
  POST: 'post',
  GET: 'get',
  FETCH: 'fetch',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};
module.exports = HTTP_METHODS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9oZWxwZXJzL2h0dHBfbWV0aG9kcy5qcyJdLCJuYW1lcyI6WyJIVFRQX01FVEhPRFMiLCJQT1NUIiwiR0VUIiwiRkVUQ0giLCJQVVQiLCJQQVRDSCIsIkRFTEVURSIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBTUEsWUFBWSxHQUFHO0FBQ25CQyxFQUFBQSxJQUFJLEVBQUUsTUFEYTtBQUVuQkMsRUFBQUEsR0FBRyxFQUFFLEtBRmM7QUFHbkJDLEVBQUFBLEtBQUssRUFBRSxPQUhZO0FBSW5CQyxFQUFBQSxHQUFHLEVBQUUsS0FKYztBQUtuQkMsRUFBQUEsS0FBSyxFQUFFLE9BTFk7QUFNbkJDLEVBQUFBLE1BQU0sRUFBRTtBQU5XLENBQXJCO0FBU0FDLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQlIsWUFBakIiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBIVFRQX01FVEhPRFMgPSB7XG4gIFBPU1Q6ICdwb3N0JyxcbiAgR0VUOiAnZ2V0JyxcbiAgRkVUQ0g6ICdmZXRjaCcsXG4gIFBVVDogJ3B1dCcsXG4gIFBBVENIOiAncGF0Y2gnLFxuICBERUxFVEU6ICdkZWxldGUnXG59XG5cbm1vZHVsZS5leHBvcnRzID0gSFRUUF9NRVRIT0RTXG4iXX0=